module.exports = __webpack_public_path__ + "img/caiwufenxi.53890c41.png";